export default "__VITE_ASSET__Bi6mlT5H__"